/**
 * Monogram helpers for CoworkerAvatar (plan 08 WP-VIS-05). Pure, so Node's
 * test runner covers them (`npm run test:unit`).
 */

/**
 * Up to two initials from a display name: "Matching Agent" -> "MA",
 * "Intake" -> "I", "jordan lee" -> "JL". Punctuation and extra spaces are
 * ignored; an empty name gives "?".
 */
export function initialsFor(name: string | null | undefined): string {
  const words = (name ?? '')
    .split(/[\s\-_/]+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean)
  if (words.length === 0) return '?'
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
}

/** A stable index in [0, count) per name, so a coworker keeps its colour between pages. */
export function toneIndexFor(name: string | null | undefined, count: number): number {
  if (count <= 0) return 0
  const text = name ?? ''
  let hash = 0
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) >>> 0
  return hash % count
}
